import { render, staticRenderFns } from "./PhotoFeatured.vue?vue&type=template&id=68e38870&scoped=true&"
import script from "./PhotoFeatured.vue?vue&type=script&lang=js&"
export * from "./PhotoFeatured.vue?vue&type=script&lang=js&"
import style0 from "./PhotoFeatured.vue?vue&type=style&index=0&id=68e38870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e38870",
  null
  
)

export default component.exports